import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { Store } from '@ngrx/store';

import { PrivaNotificationComponent } from '@priva/components/notification';
import { PrivaLocalizationModule } from '@priva/localization';

import { AppWizardStepComponent } from 'app/features/setup-wizard/components';
import { SigninFormComponent } from 'app/shared/components';
import { Credentials, PersonalUserPreferences, UserInfo } from 'app/shared/models';
import { loginSuccess, userSessionHistoryUpdated } from 'app/state/user-session/user-session.actions';

import { AppWizardStep } from '../../../components';

@Component({
    selector: 'app-enter-security-pin-wizard-step',
    templateUrl: './enter-security-pin-wizard-step.component.html',
    imports: [
        AsyncPipe,
        PrivaLocalizationModule,
        PrivaNotificationComponent,
        AppWizardStepComponent,
        SigninFormComponent,
    ],
})
export class EnterSecurityPinWizardStepComponent extends AppWizardStep {
    constructor(private store: Store) {
        super();
        super.setTitle('SETUP.STEP_3.TITLE');
    }

    protected override onShow() {
        this.canGoNext$.next(false);
    }

    onAuthorized({
        credentials,
        userInfo,
        personalUserPreferences,
    }: {
        credentials: Credentials;
        userInfo: UserInfo | undefined;
        personalUserPreferences: PersonalUserPreferences;
    }): void {
        const userSession = {
            credentials: { ...credentials },
            data: personalUserPreferences,
            startedOn: Date.now(),
            userInfo,
        };
        this.store.dispatch(loginSuccess({ userSession }));
        this.store.dispatch(userSessionHistoryUpdated({ userSession }));
        this.canGoNext$.next(true);
    }
}
